import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SpeakingSessionTableState, SpeakingSessionState, SlotCounts } from './types';

const initialState: SpeakingSessionState = {
  pageIndex: 0,
  pageSize: 25,
  sortBy: [{ id: 'date', desc: true }],
  roomSlotCounts: [],
  editedRoomSlotCounts: {
    roomId: 0,
    counts: { available: 0, awaitingApproval: 0, booked: 0, rejected: 0 },
  },
};

export const { actions, reducer } = createSlice({
  name: 'speaking-session',
  initialState,
  reducers: {
    updateTableState: (state, action: PayloadAction<SpeakingSessionTableState>) => {
      state.pageIndex = action.payload.pageIndex;
      state.pageSize = action.payload.pageSize;
      state.sortBy = action.payload.sortBy;
    },
    setEditedRoomSlotCounts: (
      state,
      action: PayloadAction<{ roomId: number; counts: SlotCounts }>
    ) => {
      state.editedRoomSlotCounts = action.payload;
    },
    setRoomSlotCounts: (state, action: PayloadAction<{ roomId: number; counts: SlotCounts }[]>) => {
      state.roomSlotCounts = action.payload;
    },
  },
});
